import React, { Component } from 'react';
import { Well } from 'react-bootstrap';
/* import wechat from './wechat.jpg'; */

class Bottom extends Component {
  render() {
    return (
      <Well className="container">
        <p>联系作者&nbsp;&nbsp;E-mail:&nbsp;<a href="mailto:fanzhh@gmail.com">fanzhh@gmail.com</a>, QQ&Wechat:&nbsp;403767822.</p>
     </Well>
    )
  }
}


export default Bottom;



// WEBPACK FOOTER //
// ./src/Bottom.js